interface Parameters {
    [key: string]: string;
}

export const buildUrl = (baseUrl: string, params: Parameters = {}) => {
    if (baseUrl?.length < 1) {
        return "";
    }
    const urlWithParams = new URL(baseUrl);

    Object.keys(params).forEach((key) => {
        urlWithParams.searchParams.append(key, params[key]);
    });

    return urlWithParams.href;
};
